<template>
  <div>
    <!-- Dialog 1: Form chuyển đổi dữ liệu V4 -->
    <DialogBase
      :visible.sync="createVisible"
      title="Chuyển đổi điểm danh và nhận xét V4"
      size="lg"
      top="5vh"
      append-to-body
      :close-on-click-modal="false"
      :use-panel="false"
      :before-close="handleBeforeCloseCreate"
      dialog-class="school-migration-dialog"
    >
      <div class="sk-dialog__content">
        <!-- Section 1: Cấu hình chuyển đổi -->
        <div class="sk-panel">
          <div class="sk-panel-head">
            <div class="sk-panel-icon">
              <i class="el-icon-refresh"></i>
            </div>
            <div>
              <p class="sk-panel-title">Cấu hình chuyển đổi dữ liệu V4</p>
              <p class="sk-panel-subtitle">
                Chọn danh sách các trường học, khoảng ngày và loại dữ liệu cần đồng bộ sang V4.
              </p>
            </div>
          </div>

          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            :disabled="submitting"
            label-position="top"
          >
            <div class="sk-form-grid">
              <el-form-item label="Danh sách trường học" prop="idSchoolList">
                <el-select
                  v-model="form.idSchoolList"
                  multiple
                  filterable
                  collapse-tags
                  placeholder="Chọn trường cần chuyển"
                  class="sk-u-w-full"
                >
                  <el-option
                    v-for="school in schoolList"
                    :key="school.id"
                    :value="school.id"
                    :label="school.id + ' - ' + school.schoolName"
                  />
                </el-select>
                <div class="selection-actions">
                  <el-button type="text" class="action-link" @click="selectAllSchools">
                    <i class="el-icon-check"></i> Chọn tất cả {{ schoolList.length }} trường
                  </el-button>
                  <span class="divider">|</span>
                  <el-button type="text" class="action-link danger-link" @click="form.idSchoolList = []">
                    <i class="el-icon-close"></i> Bỏ chọn
                  </el-button>
                  <span class="selected-badge">
                    Đã chọn: <strong>{{ form.idSchoolList.length }}</strong> trường
                  </span>
                </div>
              </el-form-item>

              <el-form-item label="Khoảng ngày dữ liệu cần chuyển" prop="dateRange">
                <el-date-picker
                  v-model="form.dateRange"
                  type="daterange"
                  unlink-panels
                  range-separator="-"
                  start-placeholder="Từ ngày"
                  end-placeholder="Đến ngày"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                  class="sk-u-w-full"
                />
                <div class="date-range-hint">
                  <i class="el-icon-info"></i> Chỉ nên chuyển tối đa 3 tháng mỗi lần để đảm bảo tốc độ và dễ theo dõi
                </div>
              </el-form-item>
            </div>

            <el-form-item label="Dữ liệu cần chuyển" prop="types" class="sk-u-mt-12">
              <el-checkbox-group v-model="form.types" class="types-checkbox-group">
                <el-checkbox
                  v-for="type in typeOptions"
                  :key="type.value"
                  :label="type.value"
                  border
                  class="type-checkbox-item"
                >
                  {{ type.label }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="Phương thức thực thi" class="sk-u-mt-12">
              <el-radio-group v-model="form.runNow">
                <el-radio :label="true" border>Chạy ngay</el-radio>
                <el-radio :label="false" border>Lưu chờ cronjob</el-radio>
              </el-radio-group>
              <p class="helper-text">
                <i class="el-icon-info"></i>
                {{ form.runNow ? 'Yêu cầu được đưa vào hàng xử lý sau khi lưu. Nếu hệ thống đang chuyển yêu cầu khác, yêu cầu này sẽ đợi lượt.' : 'Yêu cầu được lưu và chỉ chạy khi cronjob kích hoạt. Chưa có lịch chạy được cấu hình cho chức năng này.' }}
              </p>
            </el-form-item>
          </el-form>
        </div>

        <!-- Section 2: Lưu ý & Quy tắc dữ liệu -->
        <div class="sk-panel sk-panel--flat sk-u-mt-12">
          <div class="sk-panel-head">
            <div class="sk-panel-icon sk-panel-icon--warning">
              <i class="el-icon-warning-outline"></i>
            </div>
            <div>
              <p class="sk-panel-title">Lưu ý & Quy tắc dữ liệu</p>
              <p class="sk-panel-subtitle">Nguyên tắc cập nhật và ghi nhận dữ liệu khi thực thi</p>
            </div>
          </div>

          <div class="sk-note sk-note--warning">
            <i class="el-icon-time"></i>
            <span><strong>Khoảng thời gian:</strong> Chỉ nên chuyển tối đa 3 tháng/lần để đảm bảo tốc độ cập nhật dữ liệu, tối ưu hiệu năng hệ thống, giúp dễ dàng kiểm soát và theo dõi tiến độ.</span>
          </div>

          <div v-if="form.types.indexOf('ATTENDANCE') >= 0" class="sk-note sk-note--warning sk-u-mt-12">
            <i class="el-icon-warning"></i>
            <span><strong>Điểm danh:</strong> Sẽ cập nhật lại dữ liệu và có thể ghi đè chỉnh sửa đã có trên V4.</span>
          </div>

          <div class="sk-note sk-u-mt-12">
            <i class="el-icon-info"></i>
            <span><strong>Nhận xét:</strong> Nhận xét đã tồn tại được bỏ qua. Nhận xét tuần lấy trọn tuần (từ thứ Hai đến Chủ nhật); nhận xét tháng lấy trọn các tháng trong khoảng đã chọn.</span>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="sk-dialog__footer">
          <el-button class="btn-cancel" plain :disabled="submitting" @click="createVisible = false">
            Đóng
          </el-button>
          <el-button
            class="btn-save"
            type="primary"
            :loading="submitting"
            icon="el-icon-refresh"
            @click="submit"
          >
            {{ form.runNow ? 'Chuyển đổi dữ liệu' : 'Lưu chờ cronjob' }}
          </el-button>
        </div>
      </template>
    </DialogBase>

    <!-- Dialog 2: Danh sách và tiến độ yêu cầu chuyển đổi -->
    <DialogBase
      :visible.sync="jobsVisible"
      title="Yêu cầu chuyển đổi dữ liệu V4"
      size="xl"
      top="3vh"
      append-to-body
      :close-on-click-modal="false"
      :use-panel="false"
      dialog-class="school-migration-dialog"
    >
      <div class="sk-dialog__content">
        <!-- Section 1: Danh sách yêu cầu đã lưu -->
        <div class="sk-panel">
          <div class="sk-panel-head flex items-center justify-between">
            <div class="flex items-center gap-3">
              <div class="sk-panel-icon">
                <i class="el-icon-document"></i>
              </div>
              <div>
                <p class="sk-panel-title">Yêu cầu chuyển đổi đã lưu</p>
                <p class="sk-panel-subtitle">Lịch sử và trạng thái các phiên đồng bộ dữ liệu V4</p>
              </div>
            </div>
            <el-button
              size="small"
              type="primary"
              plain
              icon="el-icon-refresh"
              :loading="refreshing"
              @click="refresh(true)"
            >
              Tải lại
            </el-button>
          </div>

          <div v-if="errorText" class="sk-note sk-note--danger mb-3">
            <i class="el-icon-error"></i>
            <span>{{ errorText }}</span>
          </div>

          <el-table
            :data="jobs"
            border
            highlight-current-row
            :row-key="row => row.jobId"
            class="sk-table"
            @row-click="selectJob"
          >
            <el-table-column label="STT" type="index" width="50" align="center" />
            <el-table-column label="Ngày tạo" min-width="150" align="center">
              <template slot-scope="{ row }">
                <span class="font-medium text-slate-700">{{ dateTime(row.createdAt) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Số trường" width="105" align="center">
              <template slot-scope="{ row }">
                <el-tag size="small" type="info">{{ row.idSchoolList.length }} trường</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="Khoảng dữ liệu" min-width="190" align="center">
              <template slot-scope="{ row }">
                <span>{{ date(row.fromDate) }} – {{ date(row.toDate) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Trạng thái" min-width="150" align="center">
              <template slot-scope="{ row }">
                <el-tag :type="tagType(row.status)" size="small">
                  {{ statusLabel(row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="Tiến độ" width="130" align="center">
              <template slot-scope="{ row }">
                <span class="font-medium">{{ row.completedSteps }}/{{ row.totalSteps }} bước</span>
              </template>
            </el-table-column>
            <el-table-column label="Chi tiết" width="100" align="center" fixed="right">
              <template slot-scope="{ row }">
                <el-button class="sk-table-link" type="text" @click.stop="selectJob(row)">
                  Theo dõi
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="mtr-pagination" v-if="total > limit">
            <el-pagination
              background
              :current-page="page"
              :page-size="limit"
              :total="total"
              layout="total, prev, pager, next"
              @current-change="changePage"
            />
          </div>
        </div>

        <!-- Section 2: Chi tiết tiến độ yêu cầu -->
        <div v-if="result" class="sk-panel sk-u-mt-12" v-loading="loadingDetail">
          <div class="sk-panel-head">
            <div class="sk-panel-icon sk-panel-icon--success">
              <i class="el-icon-data-analysis"></i>
            </div>
            <div>
              <div class="flex items-center gap-2">
                <p class="sk-panel-title">Tiến độ yêu cầu: #{{ result.jobId }}</p>
                <el-tag :type="tagType(result.status)" size="small">
                  {{ statusLabel(result.status) }}
                </el-tag>
              </div>
              <p class="sk-panel-subtitle">
                Bắt đầu chạy: {{ dateTime(result.startedAt) }} · Kết thúc: {{ dateTime(result.finishedAt) }}
              </p>
            </div>
          </div>

          <div v-if="isBusy(result.status)" class="sk-note mb-3">
            <i class="el-icon-info"></i>
            <span>Tự cập nhật mỗi 5 giây khi mở hộp thoại này. Đóng hộp thoại không làm dừng tác vụ đang chạy ngầm.</span>
          </div>

          <div class="progress-box mb-4">
            <el-progress
              :percentage="percent"
              :stroke-width="16"
              :status="result.status === 'SUCCEEDED' ? 'success' : undefined"
            />
          </div>

          <el-row v-if="result.histories && result.histories.length" :gutter="14" class="history-grid mb-3">
            <el-col v-for="history in result.histories" :key="history.id" :xs="24" :md="12">
              <div class="history-card">
                <div class="history-header">
                  <span class="history-status">{{ history.statusAction }}</span>
                  <span class="history-time">{{ dateTime(history.updatedAt) }}</span>
                </div>
                <div class="history-description">{{ history.description }}</div>
              </div>
            </el-col>
          </el-row>

          <el-table :data="result.schools" border size="small" class="sk-table" row-key="idSchool">
            <el-table-column type="expand">
              <template slot-scope="{ row }">
                <div class="expand-table-wrapper p-2 bg-slate-50">
                  <el-table :data="row.steps" border size="mini" class="sk-table">
                    <el-table-column label="Dữ liệu" min-width="130">
                      <template slot-scope="{ row: step }">{{ typeLabel(step.type) }}</template>
                    </el-table-column>
                    <el-table-column label="Khoảng chuyển thực tế" min-width="190" align="center">
                      <template slot-scope="{ row: step }">
                        {{ date(step.effectiveFromDate) }} – {{ date(step.effectiveToDate) }}
                      </template>
                    </el-table-column>
                    <el-table-column label="Trạng thái" min-width="140" align="center">
                      <template slot-scope="{ row: step }">
                        <el-tag :type="tagType(step.status)" size="mini">
                          {{ step.status === 'PENDING' && result.status === 'INTERRUPTED' ? 'Chưa chạy' : statusLabel(step.status) }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column label="Đã đọc" width="85" align="right">
                      <template slot-scope="{ row: step }">
                        {{ step.sourceCount || (step.countComplete ? 0 : '—') }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="successCount" label="Thành công" width="100" align="right" />
                    <el-table-column prop="skippedCount" label="Bỏ qua" width="85" align="right" />
                    <el-table-column prop="failedCount" label="Lỗi" width="75" align="right" />
                    <el-table-column prop="unknownCount" label="Chưa xác nhận" width="120" align="right" />
                    <el-table-column label="Tiến độ / Lỗi" min-width="220">
                      <template slot-scope="{ row: step }">
                        <div class="step-stage">{{ step.stage }}</div>
                        <div v-if="step.errors && step.errors.length" class="error-text">
                          {{ step.errors.join('; ') }}
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Trường học" min-width="220">
              <template slot-scope="{ row }">
                <span class="font-medium text-slate-800">{{ schoolLabel(row.idSchool) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Điểm danh" min-width="150" align="center">
              <template slot-scope="{ row }">
                <span :class="groupLabelClass(row.steps.filter(step => step.type === 'ATTENDANCE'))">
                  {{ groupLabel(row.steps.filter(step => step.type === 'ATTENDANCE')) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="Nhận xét" min-width="160" align="center">
              <template slot-scope="{ row }">
                <span :class="groupLabelClass(row.steps.filter(step => step.type !== 'ATTENDANCE'))">
                  {{ groupLabel(row.steps.filter(step => step.type !== 'ATTENDANCE')) }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <template #footer>
        <div class="sk-dialog__footer">
          <el-button class="btn-cancel" plain @click="jobsVisible = false">
            Đóng
          </el-button>
        </div>
      </template>
    </DialogBase>
  </div>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import MigrationService from "@/services/AdminService/SchoolDataMigrationService";
import { v4 as uuid } from "uuid";

const TYPES = [
  { value: "ATTENDANCE", label: "Điểm danh" },
  { value: "EVALUATION_DAILY", label: "Nhận xét ngày" },
  { value: "EVALUATION_WEEKLY", label: "Nhận xét tuần" },
  { value: "EVALUATION_MONTHLY", label: "Nhận xét tháng" },
  { value: "EVALUATION_PERIODIC", label: "Nhận xét định kỳ" },
];
const LABELS = {
  WAITING_CRON: "Chờ cronjob",
  QUEUED: "Chờ xử lý",
  PENDING: "Chờ xử lý",
  RUNNING: "Đang chuyển",
  SUCCEEDED: "Thành công",
  NO_DATA: "Không có dữ liệu",
  PARTIAL: "Hoàn tất có lỗi",
  FAILED: "Thất bại",
  UNKNOWN: "Chưa xác nhận kết quả",
  INTERRUPTED: "Gián đoạn",
};

export default {
  name: "SchoolDataMigrationPanel",
  components: {
    DialogBase,
  },
  props: {
    schoolList: {
      type: Array,
      default: () => [],
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      typeOptions: TYPES,
      form: {
        idSchoolList: [],
        dateRange: [],
        types: TYPES.map((type) => type.value),
        runNow: true,
      },
      rules: {
        idSchoolList: [
          { type: "array", required: true, min: 1, message: "Chọn ít nhất một trường", trigger: "change" },
        ],
        dateRange: [
          { type: "array", required: true, len: 2, message: "Chọn ngày bắt đầu và kết thúc", trigger: "change" },
        ],
        types: [
          { type: "array", required: true, min: 1, message: "Chọn ít nhất một loại dữ liệu", trigger: "change" },
        ],
      },
      submitting: false,
      refreshing: false,
      loadingDetail: false,
      jobs: [],
      result: null,
      selectedJobId: null,
      page: 1,
      limit: 20,
      total: 0,
      timer: null,
      disposed: false,
      detailVersion: 0,
      refreshVersion: 0,
      submission: null,
      errorText: "",
      createVisible: false,
      jobsVisible: false,
    };
  },
  computed: {
    trackingOpen() {
      return this.active && this.jobsVisible && !this.disposed;
    },
    percent() {
      return this.result && this.result.totalSteps
        ? Math.round((this.result.completedSteps * 100) / this.result.totalSteps)
        : 0;
    },
  },
  watch: {
    active(value) {
      if (!value) {
        this.createVisible = false;
        this.jobsVisible = false;
      }
    },
    trackingOpen: {
      immediate: true,
      handler(value) {
        if (value) {
          this.refresh(false);
        } else {
          this.stopPolling();
        }
      },
    },
  },
  beforeDestroy() {
    this.disposed = true;
    this.stopPolling();
    this.detailVersion++;
  },
  methods: {
    openCreateDialog() {
      if (!this.active) return;
      this.jobsVisible = false;
      this.createVisible = true;
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate();
      });
    },
    openJobsDialog() {
      if (!this.active) return;
      this.createVisible = false;
      this.jobsVisible = true;
    },
    handleBeforeCloseCreate(done) {
      if (this.submitting) return;
      this.createVisible = false;
      if (typeof done === "function") {
        done();
      }
    },
    selectAllSchools() {
      this.form.idSchoolList = this.schoolList.map((school) => school.id);
    },
    submit() {
      if (this.submitting) return;
      this.submitting = true;
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          this.submitting = false;
          return;
        }
        const payload = {
          idSchoolList: this.form.idSchoolList.slice(),
          fromDate: this.form.dateRange[0],
          toDate: this.form.dateRange[1],
          runNow: this.form.runNow,
          types: TYPES.filter((type) => this.form.types.indexOf(type.value) >= 0).map((type) => type.value),
        };
        const encoded = JSON.stringify(payload);
        if (!this.submission || this.submission.payload !== encoded) {
          this.submission = { payload: encoded, key: uuid() };
        }
        try {
          const response = await MigrationService.create(payload, this.submission.key);
          this.result = response.data.data;
          this.selectedJobId = this.result.jobId;
          this.submission = null;
          this.page = 1;
          this.$message.success(
            payload.runNow
              ? "Đã tiếp nhận yêu cầu chuyển đổi. Theo dõi trong danh sách yêu cầu."
              : "Đã lưu yêu cầu chờ cronjob."
          );
          this.openJobsDialog();
          await this.refresh(false);
        } catch (error) {
          this.$message.error(this.errorMessage(error));
        } finally {
          this.submitting = false;
        }
      });
    },
    async refresh(manual) {
      if (!this.trackingOpen || this.refreshing) return;
      this.refreshing = true;
      const version = this.refreshVersion;
      try {
        const response = await MigrationService.list(this.page, this.limit);
        if (version !== this.refreshVersion || !this.trackingOpen) return;
        this.jobs = response.data.data.items;
        this.total = response.data.data.total;
        this.errorText = "";
        if (!this.selectedJobId && this.jobs.length) {
          this.selectedJobId = this.jobs[0].jobId;
        }
        if (this.selectedJobId) {
          await this.fetchJob(this.selectedJobId);
        }
      } catch (error) {
        if (this.trackingOpen && version === this.refreshVersion) {
          this.errorText = this.errorMessage(error);
          if (manual) this.$message.error(this.errorText);
        }
      } finally {
        this.refreshing = false;
        if (this.trackingOpen && version !== this.refreshVersion) {
          this.refresh(false);
        } else {
          this.schedulePolling();
        }
      }
    },
    async fetchJob(id) {
      if (!this.trackingOpen) return;
      const version = ++this.detailVersion;
      const response = await MigrationService.get(id);
      if (this.trackingOpen && version === this.detailVersion && id === this.selectedJobId) {
        this.result = response.data.data;
      }
    },
    async selectJob(row) {
      this.selectedJobId = row.jobId;
      this.loadingDetail = true;
      try {
        await this.fetchJob(row.jobId);
      } catch (error) {
        this.$message.error(this.errorMessage(error));
      } finally {
        this.loadingDetail = false;
        this.schedulePolling();
      }
    },
    changePage(page) {
      this.page = page;
      this.refreshVersion++;
      this.refresh(false);
    },
    stopPolling() {
      clearTimeout(this.timer);
      this.timer = null;
      this.refreshVersion++;
      this.detailVersion++;
    },
    schedulePolling() {
      clearTimeout(this.timer);
      if (!this.trackingOpen) return;
      if (
        this.errorText ||
        this.jobs.some((job) => this.isBusy(job.status)) ||
        (this.result && this.isBusy(this.result.status))
      ) {
        this.timer = setTimeout(() => this.refresh(false), 5000);
      }
    },
    isBusy(status) {
      return ["WAITING_CRON", "QUEUED", "RUNNING"].indexOf(status) >= 0;
    },
    statusLabel(status) {
      return LABELS[status] || status;
    },
    tagType(status) {
      return ["SUCCEEDED", "NO_DATA"].indexOf(status) >= 0
        ? "success"
        : ["FAILED", "UNKNOWN", "INTERRUPTED"].indexOf(status) >= 0
        ? "danger"
        : "warning";
    },
    typeLabel(type) {
      const value = TYPES.find((item) => item.value === type);
      return value ? value.label : type;
    },
    schoolLabel(id) {
      const school = this.schoolList.find((item) => item.id === id);
      return `${id} - ${school ? school.schoolName : "Trường không còn trong danh sách"}`;
    },
    groupLabel(steps) {
      if (!steps.length) return "Không chọn chuyển";
      const states = steps.map((step) => step.status);
      if (states.every((state) => state === "PENDING")) {
        return this.result.status === "INTERRUPTED"
          ? "Chưa chạy"
          : this.result.status === "WAITING_CRON"
          ? "Chờ cronjob"
          : "Chờ xử lý";
      }
      if (states.some((state) => ["PENDING", "RUNNING"].indexOf(state) >= 0)) {
        return this.result.status === "INTERRUPTED" ? "Gián đoạn / chưa chạy hết" : "Đang xử lý";
      }
      if (states.every((state) => ["SUCCEEDED", "NO_DATA"].indexOf(state) >= 0)) {
        return "Thành công";
      }
      return states.some((state) => state === "UNKNOWN") ? "Chưa xác nhận kết quả" : "Thất bại / có lỗi";
    },
    groupLabelClass(steps) {
      const label = this.groupLabel(steps);
      if (label === "Thành công") return "text-emerald-600 font-semibold";
      if (label === "Đang xử lý") return "text-blue-600 font-semibold";
      if (label === "Thất bại / có lỗi" || label === "Chưa xác nhận kết quả") return "text-rose-600 font-semibold";
      return "text-slate-600";
    },
    date(value) {
      if (!value) return "—";
      const parts = value.split("-");
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    },
    dateTime(value) {
      if (!value) return "—";
      const parts = value.split("T");
      return `${this.date(parts[0])} ${parts[1] ? parts[1].slice(0, 8) : ""}`;
    },
    errorMessage(error) {
      return error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : "Không thể kết nối để xác nhận yêu cầu/kết quả. Hãy tải lại hoặc gửi lại cùng yêu cầu.";
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog.scss";
@import "@/assets/style/sk-table.scss";

/deep/ .school-migration-dialog .el-dialog__body {
  max-height: 76vh;
  overflow-y: auto;
}

.mtr-pagination {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.selection-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
  font-size: 13px;

  .action-link {
    padding: 0;
    font-size: 12.5px;
    color: #2563eb;
    font-weight: 500;

    &:hover {
      color: #1d4ed8;
    }

    &.danger-link {
      color: #dc2626;

      &:hover {
        color: #be123c;
      }
    }
  }

  .divider {
    color: #cbd5e1;
  }

  .selected-badge {
    margin-left: auto;
    color: #475569;
    font-size: 12.5px;

    strong {
      color: #2563eb;
      font-weight: 700;
    }
  }
}

.date-range-hint {
  margin-top: 6px;
  font-size: 12px;
  color: #d97706;
  line-height: 1.4;
  display: flex;
  align-items: center;

  i {
    margin-right: 4px;
    font-size: 13px;
  }
}

.types-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .type-checkbox-item {
    margin-right: 0 !important;
    border-radius: 8px;
  }
}

.helper-text {
  margin: 8px 0 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: #64748b;

  i {
    margin-right: 4px;
    color: #3b82f6;
  }
}

.progress-box {
  background: #ffffff;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.history-grid {
  margin-top: 8px;
}

.history-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

  .history-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;

    .history-status {
      font-weight: 700;
      color: #1e293b;
      font-size: 13.5px;
    }

    .history-time {
      font-size: 12px;
      color: #64748b;
    }
  }

  .history-description {
    font-size: 12.5px;
    line-height: 1.6;
    color: #334155;
    max-height: 160px;
    overflow-y: auto;
    white-space: pre-wrap;
    word-break: break-word;
  }
}

.step-stage {
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 2px;
}

.error-text {
  color: #dc2626;
  font-size: 12px;
  line-height: 1.4;
  word-break: break-word;
}

.expand-table-wrapper {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}
</style>
